import React from 'react'
import { useTestResultsContext } from '../../../contexts/testResultsContext'
import { useTestResultsFilterContext } from '../../../contexts/testResultsFilterContext'
import { tableStyles } from '../../../utilities/stylesHelpers'
import TableHeaderRows from './tableHeaderRows'
import TestResultModal from './testResultModal'
import TestResultRow from './testResultRow'

const TestResultsTable = () => {
  const { modal } = useTestResultsContext()
  const { filteredTestResultRows, filteredContaminantGroups } = useTestResultsFilterContext()
  return (
    <div className="m-4 w-full">
      {modal.testResultModal && <TestResultModal />}
      <table className={tableStyles.table}>
        {filteredContaminantGroups && <TableHeaderRows length ={length} filteredContaminantGroups ={filteredContaminantGroups} />}
        <tbody>          
          {filteredTestResultRows.map((row, index) => (
            <TestResultRow key={index} row={row} rowIndex={index} />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TestResultsTable
